module.exports = __webpack_public_path__ + "img/software.e321fe06.jpg";